
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import 'firebase/auth';
import Layout from 'containers/Layout';
import React from 'react';
import { Box } from '@mui/material';
import MyCart from 'containers/cart/MyCart';
import { GetServerSidePropsContext } from 'next';
import { getServerSideCustomer } from 'ssr';
import { StateStatus } from 'core/design/StateStatus';
import { CURRENT_USER_GET } from 'redux/constants/users';
import { staticMetaContent } from 'static/meta';
import MyCartV2 from 'containers/cart/MyCartV2';

export default function Cart({ routerQuery }) {
    return (
        <Layout routerQuery={routerQuery} metaTags={staticMetaContent['cart']}>
            <Box style={{ backgroundColor: 'white' }}>
                <MyCartV2 routerQuery={routerQuery} />
            </Box>
        </Layout>
    );
}

 async function _getServerSideProps(context: GetServerSidePropsContext) {
    const query = context.query || {};

    const data = await getServerSideCustomer(context);

    const successObject = {
        data: null,
        errors: null,
        version: +new Date(),
        status: data.customer ? StateStatus.LOADED : StateStatus.NOT_INITIALIZED,
    };

    return {
        props: {
            routerQuery: query || {},
            authenticated: data.authenticated,
            uid: data.uid,
            initialReduxState: {
                currentUser: {
                    ...successObject,
                    data: JSON.parse(JSON.stringify(data.customer)),
                    entity: CURRENT_USER_GET.entity,
                },
            },
        },
    };
}


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/cart',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  